import { initializeApp } from "firebase/app";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import AndroidPage, { PDA_APK } from "./pages/android";
import AndroidPageSm from "./pages/android-sm";
import AndroidPageStaging from "./pages/android-staging";
import MDHHelpPage from "./pages/help-mdh";
import SMHelpPage from "./pages/help-sm";
import IniPage from "./pages/hotjar";
import IosPage from "./pages/ios";
import IosPagePactolus from "./pages/ios-pactolus";
import IosPageSm from "./pages/ios-sm";
import IosStagingSMPage from "./pages/staging/ios-sm";
import ReleaseIosPage from "./pages/release/ios";
import ReleaseAndroidPage from "./pages/release/android";
import HelpParisPage from "./pages/help-paris";
import HomeParisPage from "./pages/home-paris";
import AndroidPageParis from "./pages/android-paris";
import IosPageParis from "./pages/ios-paris";
import QrParisPage from "./pages/qr-paris";
import IosPageParisTest from "./pages/ios-paris-staging";
import IosPageStaging from "./pages/ios-staging";
import InstallTSPageParis from "./pages/install-troubleshooting-paris";

function App() {
  const firebaseConfig = {
    apiKey: "AIzaSyASrK_zZe_Kg3ovJhXGq57ThFEMlMR27DY",
    authDomain: "mi-local-20965.firebaseapp.com",
    databaseURL: "https://mi-local-20965-default-rtdb.firebaseio.com",
    projectId: "mi-local-20965",
    storageBucket: "mi-local-20965.appspot.com",
    messagingSenderId: "972526177556",
    appId: "1:972526177556:web:04a588f3e204e9acb20601",
    measurementId: "G-XSB17LYNGH",
  };
  // Initialize Firebase
  initializeApp(firebaseConfig);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<IniPage />} />
        <Route path="/ios" element={<IosPage />} />
        <Route path="/ios-staging" element={<IosPageStaging />} />
        <Route path="/ios-sm" element={<IosPageSm />} />
        <Route path="/android-sm" element={<AndroidPageSm />} />
        <Route path="/android" element={<AndroidPage />} />
        <Route path="/android-pda" element={<AndroidPage apkUrl={PDA_APK} />} />
        <Route path="/android-staging" element={<AndroidPageStaging/>}/>
        <Route path="/ayuda-sm" element={<SMHelpPage />} />
        <Route path="/qr-paris" element={<QrParisPage />} />
        <Route path="/android-paris" element={<AndroidPageParis />} />
        <Route path="/ios-paris" element={<IosPageParis />} />
        <Route
          path="/install-troubleshooting-paris"
          element={<InstallTSPageParis />}
        />
        <Route path="/test/ios-paris" element={<IosPageParisTest />} />
        <Route path="/ayuda-paris" element={<HelpParisPage />} />
        <Route path="/home-paris" element={<HomeParisPage />} />
        <Route path="/ayuda-mdh" element={<MDHHelpPage />} />
        {/*<Route path="/staging-ios-sm" element={<IosStagingSMPage/>}/>*/}
        {/*<Route path="/ios-pactolus" element={<IosPagePactolus/>}/>*/}
        {/*<Route path="/release-ios" element={<ReleaseIosPage/>}/>*/}
        {/*<Route path="/release-android" element={<ReleaseAndroidPage/>}/>*/}
        {/*<Route path="**" element={<IosPage/>}/>*/}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
